import React, { useRef } from 'react'
import useSize from './useSize'
import { scaleLog, scaleLinear } from 'd3-scale'
import { line, curveBasis } from 'd3-shape'

import './styles.scss'

const f = new Intl.NumberFormat('de-CH')

type ChartProps = {
  values: number[]
  log: boolean
  flipVertical?: boolean
}
const markerRad = 2.5
const padding = 6
export const Chart: React.FC<ChartProps> = ({
  values,
  log,
  flipVertical = false
}) => {
  if (!values) return null
  const [container, size] = useSize()
  const svg = useRef<SVGSVGElement>(null)
  //
  const width = size.width
  const height = size.height
  const gutterTop = padding
  const gutterRight = padding
  const gutterLeft = 0
  const gutterBottom = padding
  const plotArea = {
    top: gutterTop,
    right: width - gutterRight,
    left: gutterLeft,
    bottom: height - gutterBottom
  }
  const yFunction = d => {
    return yAxisScale(+d)
  }
  const xFunction = (d, i) => xAxisScale(i)
  const xAxisScale = React.useMemo(
    () =>
      scaleLinear()
        .domain([0, values.length])
        .range([plotArea.left, plotArea.right]),
    [size]
  )

  const yAxisScale = React.useMemo(
    () =>
      scaleLinear()
        .domain(
          flipVertical
            ? [Math.max.apply(null, values), Math.min.apply(null, values)]
            : [Math.min.apply(null, values), Math.max.apply(null, values)]
        )
        .range([plotArea.bottom, plotArea.top]),
    [size]
  )

  const lineFunction = React.useMemo(
    () =>
      line()
        .x(xFunction)
        .y(yFunction),
    [size]
  )

  return (
    <div className='chart' ref={container}>
      <svg ref={svg} width={width} height={height}>
        {' '}
        <defs>
          <marker
            id={'end'}
            className='endMarker'
            markerWidth={markerRad * 2}
            markerHeight={markerRad * 2}
            refX={markerRad}
            refY={markerRad}
          >
            <circle cx={markerRad} cy={markerRad} r={markerRad} stroke='none' />
          </marker>
        </defs>
        <path d={lineFunction(values)} markerEnd={'url(#end)'} />
      </svg>
    </div>
  )
}
